import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon: string;
  title: string;
  desc?: string;
  actionTo?: string;
  actionLabel?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  icon,
  title,
  desc,
  actionTo,
  actionLabel,
  children,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
          <i className={`${icon} text-xl`} aria-hidden="true"></i>
        </span>
        <div>
          <h2 className="text-lg font-bold text-foreground-950 md:text-xl">{title}</h2>
          {desc && <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{desc}</p>}
        </div>
      </div>
      {children}
      {actionTo && actionLabel && (
        <Link
          to={actionTo}
          className="whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-s-line ml-0.5 align-middle" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}